"use strict";

import angular from "angular";

import template from "./card-nps.component.html";
import "./card-nps.component.scss";

import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";

class CardNpsComponent {
    constructor($filter, $rootScope, ThemesService) {
        this.$rootScope = $rootScope;
        this.ThemesService = ThemesService;

        this.FormatUnits = new FormatUnits($filter);

        this.notes = new Array(10);
        this.loading = false;

        this.percentageValue = "0%";
    }

    $onInit() {
        this.setVisualization();
        this._setPercentageValue();

        this.$rootScope.$on("THEMES_SERVICE_THEME_CHANGED", (event, theme) => {
            this.loading = true;
            this.setVisualization();
            setTimeout(() => {
                this.loading = false;
            }, 100);
        });
    }

    $onChanges() {
        this.setVisualization();
        this._setPercentageValue();
    }

    setVisualization() {
        const theme = this.ThemesService.getTheme();

        const high = {
            chart: {
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                chart: {
                    type: "gauge",
                    plotBackgroundColor: null,
                    plotBackgroundImage: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                    height: "100%"
                },
                title: {
                    text: ""
                },
                pane: {
                    startAngle: -90,
                    endAngle: 89.9,
                    background: null
                },
                tooltip: { enabled: false },
                yAxis: {
                    min: -100,
                    max: 100,
                    plotBands: [
                        {
                            from: -100,
                            to: 0,
                            thickness: "50%",
                            color: "#d60436" // red
                        },
                        {
                            from: 0,
                            to: 30,
                            thickness: "50%",
                            color: "#f1ad00" // yellow
                        },
                        {
                            from: 30,
                            to: 100,
                            thickness: "50%",
                            color: "#9fcc65" // green
                        }
                    ],
                    tickWidth: 0,
                    minorTickWidth: 0,
                    labels: {
                        distance: 15,
                        style: {
                            fontWeight: 600,
                            fontSize: "12px",
                            color: "#2E5573"
                        }
                    }
                },

                plotOptions: {
                    gauge: {
                        dial: {
                            radius: "92%",
                            rearLength: "-40%",
                            baseWidth: 6,
                            topWidth: 0
                        },
                        pivot: {
                            radius: 0
                        }
                    }
                },

                series: [
                    {
                        name: "NPS",
                        data: [parseInt(this.viewConfigs.npsAverage) || 0],
                        dataLabels: {
                            useHTML: true,
                            color: "#2E5573",

                            format:
                                '<div class="vf-report-gauge-label" style="text-align:center"><span style="font-size:22px;color: #2E5573;">{y}</span></div>',
                            y: -34
                        },
                        dial: {
                            backgroundColor: "#2E5573"
                        }
                    }
                ]
            }
        };

        if (theme === "dark") {
            high.chart.yAxis.plotBands[0].color = "#DA3633";
            high.chart.yAxis.plotBands[1].color = "#E3B341";

            high.chart.yAxis.labels.style.color = "#a5a6a7";
            high.chart.series[0].dataLabels.color = "#a5a6a7";
            high.chart.series[0].dial.backgroundColor = "#a5a6a7";
            high.chart.series[0].dataLabels.format =
                '<div class="vf-report-gauge-label" style="text-align:center"><span style="font-size:22px;color: #a5a6a7;">{y}</span></div>';
        }

        this.visualization = high;
    }
    _setPercentageValue() {
        const percentage =
            (this.viewConfigs.value / this.viewConfigs.total) * 100;
        this.percentageValue = this.FormatUnits.formatValue(
            "percentage",
            percentage,
            2
        );
    }
}

CardNpsComponent.$inject = ["$filter", "$rootScope", "ThemesService"];

const name = "cardNpsComponent";
const def = {
    bindings: {
        labelTitle: "<",
        infoTooltip: "<",
        viewConfigs: "<",
        type: "<",
        color: "<",
        sent: "<"
    },
    controller: CardNpsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
